export default __webpack_public_path__ + "static/media/projectInterior.837672e1.bin";